/**
 * @generated SignedSource<<419ca3097b8b9c3f30aaf8370a5a0314>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSkillAutocomplete_Query$variables = {
  after?: string | null | undefined;
  industryIds?: ReadonlyArray<string> | null | undefined;
  search?: string | null | undefined;
};
export type useSkillAutocomplete_Query$data = {
  readonly skills: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type useSkillAutocomplete_Query = {
  response: useSkillAutocomplete_Query$data;
  variables: useSkillAutocomplete_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "industryIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 2000
      },
      {
        "kind": "Variable",
        "name": "industryIds",
        "variableName": "industryIds"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "SkillConnection",
    "kind": "LinkedField",
    "name": "skills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Skill",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSkillAutocomplete_Query",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSkillAutocomplete_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "4338f56de47077e449ebadaaf7632023",
    "id": null,
    "metadata": {},
    "name": "useSkillAutocomplete_Query",
    "operationKind": "query",
    "text": "query useSkillAutocomplete_Query(\n  $search: String\n  $industryIds: [ID!]\n  $after: String\n) {\n  skills(search: $search, industryIds: $industryIds, after: $after, first: 2000) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n    pageInfo {\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "480d8000ac257e697211933c67aecd9d";

export default node;
